module.exports = __webpack_public_path__ + "static/media/a-4-a.8147d4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-4-a.jpg
// module id = 1100
// module chunks = 33